import { render } from "./DepositTheosMintedNft.vue?vue&type=template&id=877bb332&scoped=true"
import script from "./DepositTheosMintedNft.vue?vue&type=script&lang=js"
export * from "./DepositTheosMintedNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/chooseToDepositNft.scss?vue&type=style&index=0&id=877bb332&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877bb332"]])

export default __exports__